import React, { Component } from 'react';
import { getinsightcontent } from '../../API/FetchCall';
import { FormGroup, Label, Input } from "reactstrap";
import { Link } from 'react-router-dom';
import { BASE_URL, IMG_URL } from '../../constant';

class ArticleSmall extends React.Component {
    constructor(props) {
        super(props);
        console.log('this.props', window.location.pathname)
        this.state = {
            user_id: '',
            location: localStorage.getItem('current_location') ? localStorage.getItem('current_location') : 'Bengaluru',
            vertical:this.props.pageinfo,
            suggestions: [],
            contentList: [],
            locality:'' 
        };
      
         
    }

    componentDidMount() {
        let THIS = this;
        let auth = localStorage.getItem("logged_auth");
        let data_auth = (localStorage.getItem("myData"));
        if (data_auth) {
            let auth_data = JSON.parse(data_auth)
            this.setState({
                logged_name: auth_data.first_name + ' ' + auth_data.last_name,
                authe: true,
                user_id: auth_data.user_id,
            });
        }
        this.topics();
    }



 
  topics = async () => {
    try {
        let req = JSON.stringify({
            role: 4,
            category: this.props.param.category_id
        })
        const response = await getinsightcontent(req);
        if (response.status === 1) {
            this.setState({ contentList: response.list });
        } else {
            this.setState({ contentList: [] });
        }

    } catch (error) {
        this.setState({ error: true });
    }
};
 
    render() {


        const inputPropsD = {
        value: this.state.locality,
        onChange: this.onAutoSuggestChange,
        name: 'locality',
        className: 'form-control'
      };
        
        const {value, suggestions, city, isothers, localities, fromblog, fromvertical, subcat2, vertical} = this.state;

        return (
            <React.Fragment>
                <div>
                    <div className="left-side-box">
                        <div className="left-head trend-head" id="articles_section"> Articles and Blogs </div>
                        <div className="left-side-body">
                            <ul className='related-topics'>
                                {this.state.contentList.map((content, i) => {
                                    let THIS = this;
                                    let cont = (content.title.length > 40) ? content.title.substring(0, 40) + '... ' : content.title;
                                    let bannerimg = (content.banner_image) ? content.banner_image : 'https://api.bewise.in/uploads/insights/insight_bannerbraznx.png';
                                    return (
                                        <React.Fragment>
                                            <div className='row insight-list-page'>
                                                <div className='col-md-3'>
                                                    {(content.banner_image != '') &&
                                                        (<img src={bannerimg} className="insight-home-custome-img" alt='Banner Image' />)
                                                    }
                                                </div>
                                                <div className='col-md-9 relatedLi'>
                                                    <p className=''>{cont}</p>
                                                    <small> <a href={BASE_URL + 'articles-blogs/' + content.slug_term} target='_blank' className="" >Read More</a></small>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                        // <li className="relatedLi">
                                        //     <span className=''>{cont}</span>
                                        //     <small> <a href={'insight-details/' + content.insight_id} target='_blank' className="" >Read More</a></small>
                                        // </li>

                                    )
                                })}

                            </ul>
                        </div>
                    </div>
                </div>
                
            </React.Fragment >
        );
    }
}
export { ArticleSmall };
